import { AZUREB2CSERVICE_INIT, CLEAR_USER_DATA } from '../../constants/actionTypes';

export const initialUserState = { user: null, isAuth: false, isLoginDone: false };

// Helper function to save user data to session storage
const saveUserToSession = (userData) => {
  try {
    if (userData && userData.isAuth && userData.user) {
      sessionStorage.setItem('userData', JSON.stringify(userData));
    } else {
      sessionStorage.removeItem('userData');
    }
  } catch (error) {
    console.error('Error saving user data to session storage:', error);
  }
};

// Helper function to load user data from session storage
const loadUserFromSession = () => {
  try {
    const userData = sessionStorage.getItem('userData');
    return userData ? JSON.parse(userData) : initialUserState;
  } catch (error) {
    console.error('Error loading user data from session storage:', error);
    return initialUserState;
  }
};

export function user(state = loadUserFromSession(), action) {
  switch (action.type) {
    case AZUREB2CSERVICE_INIT:
      const newState = {
        ...state,
        user: action.data.user,
        isAuth: action.data.isAuth,
        isLoginDone: true,
      };
      saveUserToSession(newState);
      return newState;
    case CLEAR_USER_DATA:
      saveUserToSession(null);
      return {
        ...initialUserState,
      };
    default:
      return state;
  }
}
